import React from "react";
import "./footer.css";
import { LiaResearchgate } from "react-icons/lia";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="social-links">
        <Link
          to="https://www.researchgate.net/profile/Abhishek-12"
          target=" _main"
        >
          <LiaResearchgate />
        </Link>
        <Link to="mailto:abhishekiit95@gmail.com">
          <MdEmail />
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
